import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslations } from "@/lib/i18n/intl";
import { keys } from "@/lib/i18n/portal";
import { ADMIN_ROLES } from "@/lib/auth/admin-roles";
import { useSessionQuery } from "@/shared/services/useSessionQuery";
import { BackButton } from "@/shared/layout/BackButton";
import { CreateForm } from "../components/CreateForm";
import { LoadingSkeleton, SectionCard } from "@a2z/ui";

type AdminAdminCreatePageClientProps = {
  locale: string;
};

export function CreateAdminPage({
  locale,
}: AdminAdminCreatePageClientProps) {
  const navigate = useNavigate();
  const t = useTranslations();
  const { data: session, isLoading } = useSessionQuery();
  const isSuperAdmin =
    session?.admin?.roles?.includes(ADMIN_ROLES.SUPER_ADMIN) ?? false;

  useEffect(() => {
    if (!isLoading && !isSuperAdmin) {
      navigate(`/${locale}/admin`, { replace: true });
    }
  }, [isLoading, isSuperAdmin, locale, navigate]);

  if (isLoading || !isSuperAdmin) {
    return <LoadingSkeleton variant="card" />;
  }

  return (
    <section className="flex w-full max-w-2xl flex-col gap-5 lg:px-6 lg:py-6">
      <BackButton
        label={t(keys.common.back)}
        fallbackHref={`/${locale}/admin/admins`}
      />
      <SectionCard title={t(keys.admin.adminsNewTitle)}>
        <CreateForm locale={locale} />
      </SectionCard>
    </section>
  );
}
